import { render, staticRenderFns } from "./BpPaginator.vue?vue&type=template&id=48caaa3a&"
import script from "./BpPaginator.vue?vue&type=script&lang=js&"
export * from "./BpPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports